import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import bookingActions from 'actions/bookings/actions'
import Table from 'components/shared/table/table'
import THead from 'components/shared/table/table-header'
import TBody from 'components/shared/table/table-body'
import TRow from 'components/shared/table/table-row-dropdown'
import TCol from 'components/shared/table/table-column'
import TablePagination from 'components/shared/table/table-pagination'
import SortIcon from 'components/shared/icons/sort'
import SortedUp from 'components/shared/icons/sortedUp'
import SortedDown from 'components/shared/icons/sortedDown'
import ColStatus from '../col-status'

const PaidList = ({ selectedVenue, headers, list, sort, page, limit, total, pagePaid, sortPaid, fetchPaid }) => {
  useEffect(() => { fetchPaid({ selectedVenue }) }, [selectedVenue, limit, page, sort])

  const DisplayDetails = item => {
    const { fromDetail, toDetail, notes, client, email, phone } = item

    return (
      <ul className="my-3 text-sm">
        <li>Request Date:
          <div className="flex">
            <div className="border-r-2 mx-1"></div>
            <div>
              <p className="text-sm">{`from: ${fromDetail}`}</p>
              <p className="text-sm">{`to: ${toDetail}`}</p>
            </div>
          </div>
        </li>
        <li>{`Notes: ${notes}`}</li>
        <li>{`Client Name: ${client}`}</li>
        <li>{`Email: ${email}`}</li>
        <li>{`Phone: ${phone}`}</li>
      </ul>
    )
  }

  return (
    <div className="merchant-paid-list">
      <div className="overflow-auto mt-5">
        <Table classes="w-full border-collapse">
          <THead classes="text-xs bg-lightgray font-semibold">

          {headers.map((header, key) => {
                  let sortIcon = <SortIcon />
                  let nextOrder = 'desc'

                  if (sort.field === header.field) {
                    if (sort.order === 'desc') {
                      sortIcon = <SortedDown />
                      nextOrder = 'asc'
                    } else {
                      sortIcon = <SortedUp />
                    }
                  }

                  return (
                  <TCol
                    classes="p-3 text-primary-black"
                    key={key}
                    align={header.align || 'left'}
                    onClick={() => header.sortable && sortPaid({ field: header.field, order: nextOrder })}
                  >
                    <div
                      className={`flex items-center gap-1 ${header.sortable ? 'cursor-pointer' : ''}`}
                    >
                      {header.name} {header.sortable && sortIcon}
                    </div>
                  </TCol>
                )
              })}
          </THead>
          <TBody>
            {list.map(item => (
              <TRow classes="border-t text-sm hover:bg-gray-100"
                key={item.id} PassedComponent={() => DisplayDetails(item.details)}>
                <TCol classes="p-3">{item.createDate}</TCol>
                <TCol classes="p-3">{item.date}</TCol>
                <TCol classes="p-3">{item.client}</TCol>
                <TCol classes="p-3 text-primary-orange">
                  <a href={item.spaceLink}>{item.space}</a>
                </TCol>
                <ColStatus classes="p-3 font-semibold text-xs" status={item.status} />
                <TCol classes="p-3">{item.amount}</TCol>
                <TCol classes="p-3" align="left">
                  <ul className="flex font-semibold text-center text-primary-orange">
                    <li className="">
                      <Link to={`/merchant/messages/${item.conversation_id}/conversation`} target="_blank">Message</Link>
                    </li>
                  </ul>
                </TCol>
              </TRow>
            ))}
          </TBody>
        </Table>
      </div>
      <TablePagination
        currentPage={page}
        onPageChange={(newPage) => pagePaid({ page: newPage })}
        onPageSizeChange={(newPageSize) => pagePaid({ limit: newPageSize })}
        pageSize={limit}
        totalCount={total}
        className="mt-5"
      />
    </div>
  )
}

PaidList.propTypes = {
  selectedVenue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  headers: PropTypes.array.isRequired,
  fetchPaid: PropTypes.func.isRequired,
  list: PropTypes.array,
  page: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  pagePaid: PropTypes.func.isRequired,
  sort: PropTypes.object.isRequired,
  sortPaid: PropTypes.func.isRequired,
}

const mapStateToProps = ({ bookings }) => ({
  headers: bookings.merchant.paid.headers,
  list: bookings.merchant.paid.list,
  page: bookings.merchant.paid.page,
  limit: bookings.merchant.paid.limit,
  total: bookings.merchant.paid.total,
  sort: bookings.merchant.paid.sort,
})

const mapDispatchToProps = {
  fetchPaid: bookingActions.fetchMerchantPaid,
  pagePaid: bookingActions.pageMerchantPaid,
  sortPaid: bookingActions.sortMerchantPaid,
}

export default connect(mapStateToProps, mapDispatchToProps)(PaidList)
